import { IPaymentSettingsItem } from "web/types/Payment";

import { ONLINE_PAYMENTS_TYPE } from "../consts";

const sortRuleOnlineLast = (
  firstPayment: IPaymentSettingsItem,
  secondPayment: IPaymentSettingsItem
) => {
  if (firstPayment.type === ONLINE_PAYMENTS_TYPE) {
    return 1;
  }

  if (secondPayment.type === ONLINE_PAYMENTS_TYPE) {
    return -1;
  }

  return 0;
};

export default sortRuleOnlineLast;
